import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/General/PluginAddDeleteList";
import {PostToPbx} from "../../../../api/http-post";
import {GetFieldsAdditional, GetFieldsAdditional2} from "../../../../constants";


class SettingDatabaseAttributePage2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Modules: [],
            Entities: [],
            isLoading: false,
            component: "list",
            newEntry: {},
            selectedCompany:"",
            selectedEntity:"",
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("Projects","Projects");
        await this.loadData("Entities","Entities");
        /*

        await this.loadData("product","Products")
        */
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            let res=[];
            if(data!==null){
                res=data.RESULT
            }
            await _this.setState({
                [stateKey]: res
            })
        });
    }

    /*
   type Fields struct {


	Category string

	FieldName        string
	DataType         string
	DisplayTable     bool
	DisplaySelection bool
	LinkEntity       string

	Options       map[string]interface{}
	DefaultValue  string
	Position      float64
	Section       string
	AutoGenerated string
	SameAs        string

	Unique    bool
	Mandatory bool
	Name      bool
	Surname   bool
	Username  bool
	Password  bool
	Email     bool
	Phone     bool
	Required  bool

}
     */
    getPrefixedListField = () => {
        return GetFieldsAdditional2();
    }


    render() {

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup project form structure</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"attributes"}
                            fields={this.getPrefixedListField()}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "module", type: "string"},
                                {key: "fieldname", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"attributes"}
                            addFormText={"Attribute"}
                            stepTitle={"Set Up new attribute"}
                            displayRules={[
                                {rowKey: "org", stateKey: "selectedCompany"},
                                {rowKey: "module", stateKey: "selectedProject"}
                            ]}
                            filterByCompany={true}
                            filterByModule={true}
                            injectFields={[
                                {
                                    rowKey: "Org",
                                    stateKey: "selectedCompany",
                                    errorMsg: "Sorry you can't save, Please select your company!"
                                },
                                {
                                    rowKey: "Module",
                                    stateKey: "selectedProject",
                                    errorMsg: "Sorry you can't save, Please select your Project!"
                                },
                            ]}
                            injectStaticValue={[

                            ]}
                            extra={[]}
                        />
                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(SettingDatabaseAttributePage2);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
